import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=25884f6d&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25884f6d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25884f6d')) {
      api.createRecord('25884f6d', component.options)
    } else {
      api.reload('25884f6d', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=25884f6d&scoped=true&", function () {
      api.rerender('25884f6d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2k9cxPCNEdpbi/JS/comp/SearchFilterTokens.vue"
export default component.exports